import { DocumentMetaProperties, IDocumentData } from '@lifetools/shared-database';

export const filterArchivedDocuments = (data: IDocumentData[]): IDocumentData[] => (
  data
    ? data.filter(document => !document[DocumentMetaProperties.Archived])
    : []
);
